export default class InventoryVenueWine{
    constructor() {
        this.id = null;
        this.actualAmountFloat = null;
        this.venueWine = null;
        this.inventoryVenueWineState = null;
        this.sellingPrice = null;
        this.purchasePrice = null;
        this.targetAmountFloat = null;
        this.shelf = null;
        this.year = null;
        this.bottleSize = null;
        this.canUpdatePurchasePrice = null;
        this.duplicate = null;
    }
}